import { registerView, View, ViewComponent } from "@frui.ts/views";
import { formatBankAccount } from "@edaz/utils/bankAccount";
import { observer } from "mobx-react-lite";
import React from "react";
import BankTransferViewModel from "viewModels/common/payment/bankTransferViewModel";
import AlertWithInfoIcon from "views/common/alertWithInfoIcon/alertWithInfoIcon";
import { Col, Jumbotron, Row } from "react-bootstrap";
import { QRCode } from "react-qr-svg";
import SepaInstructions from "./sepaInstructions";
import classNames from "classnames";
import styles from "./bankTransfer.module.scss";

const BankTransfer: ViewComponent<BankTransferViewModel> = observer(({ vm }) => {
  const ta = (attribute: string, model?: string) => vm.localizationService.translateAttribute(model || "payment", attribute);
  const tg = (code: string) => vm.localizationService.translateGeneral(code);

  return (
    <>
      {vm.chargeOrder && (
        <Row>
          <Col sm={12} md={7} className="mb-3">
            <Jumbotron className="mb-3 mb-md-0 mb-sm-3 p-7 w-100 multi-eshop">
              <Row>
                <Col xs={12}>
                  <h3>{tg("eshop.transfer.title")}</h3>
                </Col>
              </Row>
              <Row>
                {vm.qrcode && (
                  <Col md={12} lg={4} className="pb-4">
                    <QRCode value={vm.qrcode} className="m-0 p-0" />
                  </Col>
                )}
                <Col md={12} lg={8} className="pr-0">
                  <Col className="p-0">
                    <Row className="mb-3">
                      <Col>
                        <span className="font-weight-bold">{ta("subject")}</span>
                        <div>{tg("eshop.transfer.address")}</div>
                        <div>
                          {ta("organizationIdentifier", "organization")}
                          {": "}
                          <span className={styles.disableLinkTel}>{tg("eshop.transfer.identificationNumber")}</span>
                        </div>
                      </Col>
                    </Row>
                    <Row className="mb-3">
                      <Col>
                        <span className="font-weight-bold">{ta("bankAccount")}</span>
                        <div className="text-nowrap">
                          <span className={styles.disableLinkTel}>
                            {formatBankAccount(vm.chargeOrder.transferPayment.bankAccount)}
                          </span>
                        </div>
                      </Col>
                    </Row>
                    {vm.isMultiEshopOrder && (
                      <Row className="mb-3">
                        <Col>
                          <span className="font-weight-bold">{ta("bankAccountIban")}</span>
                          <div className="text-nowrap">
                            <span className={styles.disableLinkTel}>{vm.chargeOrder.transferPayment.iban}</span>
                          </div>
                        </Col>
                      </Row>
                    )}
                    <Row className="mb-3">
                      <Col>
                        <span className="font-weight-bold">{ta("variableSymbol")}</span>
                        <div className="text-nowrap">
                          <span className={styles.disableLinkTel}>{vm.chargeOrder.transferPayment.variableSymbol}</span>
                        </div>
                      </Col>
                    </Row>
                    <Row>
                      <Col>
                        <span className="font-weight-bold">{ta("price")}</span>
                        <div className="text-nowrap">{vm.price}</div>
                      </Col>
                    </Row>
                  </Col>
                </Col>
              </Row>
              <SepaInstructions vm={vm} />
              <AlertWithInfoIcon variant="warning" className="mt-7">
                <span>{vm.bankTransferInfo}</span>
              </AlertWithInfoIcon>
            </Jumbotron>
          </Col>
          <Col sm={12} md={5}>
            <div className="mb-5">
              <View vm={vm.children[0]} />
            </div>
            <View vm={vm.children[1]} />
          </Col>
        </Row>
      )}
    </>
  );
});

registerView(BankTransfer, BankTransferViewModel);
